// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__kyb4z","calendarButtons":"ClockData_calendarButtons__1K1r8"};